export const RepRates = {
  startFrom: '8.9%',
  borrowAmount: '£8,000',
  term: '60 months',
  repAPR: '18.5%',
  amountPayable: '£199 a month',
  totalCostOfCredit: '£3,954',
  totalAmountPayable: '£11,954'
}
